module.exports = __webpack_public_path__ + "site_static/img/solution3.6077c67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solution3.png
// module id = 1uwO
// module chunks = 0